import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'flexyoo-employee-basket-progress-bar',
  templateUrl: './employee-basket-progress-bar.component.html',
  styleUrl: './employee-basket-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmployeeBasketProgressBarComponent {
  readonly used = input.required<number>();
  readonly total = input.required<number>();
  readonly color = input.required<string>();

  protected readonly fillPercentage = computed(() => {
    const total = this.total();
    if (total <= 0) {
      return 0;
    }

    return Math.min(100, (this.used() / total) * 100);
  });
}
